import axios from "axios";

const configuredBaseURL =
  process.env.REACT_APP_API_BASE_URL || "https://api.trophynnnassets.com";
const ADMIN_TOKEN_KEY = "tna_admin_token";

export const api = axios.create({
  baseURL: configuredBaseURL.replace(/\/$/, ""),
  headers: { "Content-Type": "application/json" },
});

api.interceptors.request.use((config) => {
  const adminToken = localStorage.getItem(ADMIN_TOKEN_KEY);
  if (adminToken) config.headers.Authorization = `Bearer ${adminToken}`;
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401 && window.location.pathname.startsWith("/admin")) {
      localStorage.removeItem("tna_admin_token");
      localStorage.removeItem("tna_admin_user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;
